module.exports = __webpack_public_path__ + "img/1440x480 kypho.acd71003.png";